<ul class="stepperWrapper" *ngIf="languageService.getLanguage() !== 'ar'">
  <li [ngClass]="{ done: step.class === 'done', stepper: step.id !== '6', stepperEnd: step.id === '6' }" *ngFor="let step of englishSteps">{{ step.id }}</li>
</ul>
<div class="tourDescription" *ngIf="languageService.getLanguage() !== 'ar' && englishSteps[step - 1].description !== ''" [innerHTML]="englishSteps[step - 1].description"></div>

<ul class="stepperWrapper" *ngIf="languageService.getLanguage() === 'ar'">
  <li [ngClass]="{ done: step.class === 'done', stepper: step.id !== '6', stepperEnd: step.id === '6' }" *ngFor="let step of arabicSteps">{{ step.id }}</li>
</ul>
<div class="tourDescription" *ngIf="languageService.getLanguage() === 'ar' && arabicSteps[step - 1].description !== ''" [innerHTML]="arabicSteps[step - 1].description"></div>
